import LogoMark from "../images/LogoMark";
import "./SidebarHeader.css";

export default function SidebarHeader() {
    return (
        <div className="sidebar-header">
            <LogoMark size={24}/>
            <p>Eolass</p>
        </div>
    );
}